/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createCustomerConsumptionWithProjectionFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, type CustomerConsumptionWithProjection, type ProblemDetails } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type DateOnly, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /customers/{customer-id}/consumption/projection
 */
export interface ProjectionRequestBuilder extends BaseRequestBuilder<ProjectionRequestBuilder> {
    /**
     * GetCustomerConsumptionWithProjection
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<CustomerConsumptionWithProjection>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<ProjectionRequestBuilderGetQueryParameters> | undefined) : Promise<CustomerConsumptionWithProjection | undefined>;
    /**
     * GetCustomerConsumptionWithProjection
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<ProjectionRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * GetCustomerConsumptionWithProjection
 */
export interface ProjectionRequestBuilderGetQueryParameters {
    projectionDate?: DateOnly;
}
/**
 * Uri template for the request builder.
 */
export const ProjectionRequestBuilderUriTemplate = "{+baseurl}/customers/{customer%2Did}/consumption/projection{?ProjectionDate*}";
/**
 * Mapper for query parameters from symbol name to serialization name represented as a constant.
 */
const ProjectionRequestBuilderGetQueryParametersMapper: Record<string, string> = {
    "projectionDate": "ProjectionDate",
};
/**
 * Metadata for all the requests in the request builder.
 */
export const ProjectionRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: ProjectionRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createCustomerConsumptionWithProjectionFromDiscriminatorValue,
        queryParametersMapper: ProjectionRequestBuilderGetQueryParametersMapper,
    },
};
/* tslint:enable */
/* eslint-enable */
